/* eslint-disable no-irregular-whitespace */
import * as React from 'react';

import * as styles from './styles.css';
import { clsx } from 'clsx';
import { Button, UIHeading1, UIText1 } from '@cian/ui-kit';
import { IconActionCopy16 } from '@cian/ui-kit-design-tokens/icons';

interface IReferralLinkFallbackModalContentProps {
  isPhone: boolean;
  onClick: () => void;
}

export const ReferralLinkFallbackModalContent: React.FC<IReferralLinkFallbackModalContentProps> = ({
  isPhone,
  onClick,
}) => {
  return (
    <div className={clsx(isPhone ? styles['container-mobile'] : styles['container'])}>
      <span className={styles['heading']}>
        <UIHeading1>Ваша ссылка готова</UIHeading1>
      </span>
      <div className={styles['content']}>
        <UIText1>Ссылку привяжем к вашему номеру телефона для надёжности</UIText1>
      </div>
      <div className={clsx(isPhone ? styles['button-mobile'] : styles['button'])}>
        <Button
          size="M"
          onClick={onClick}
          fullWidth={isPhone}
          beforeIcon={<IconActionCopy16 color="icon-on-bright-default" />}
        >
          Скопировать ссылку
        </Button>
      </div>
    </div>
  );
};
